module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_4.f255e7cb.png";